export default __webpack_public_path__ + "static/media/partner-dresden.37065eec.webp";